
  const parsePathParams = (path) => {
    const segments = path.split('/').filter(Boolean); // Split path and filter out empty segments
    let para_type = 'all';

  // && segments[0] === 'lemma'
    if (segments.length >= 2) {
      para_type = segments[1] || 'all';
    }
  
    return { para_type };
  };
  
  const parseQueryParams = (search) => {
    const params = new URLSearchParams(search);
    const para_name = params.get('name') || 'all';
    const para_rating = params.get('rating') || '=-1';// not using 
    const para_reviews = params.get('review') || '=-1'; // not using 
    const para_sort_by = params.get('sort') || 'best-match';
    const para_page = params.get('page') ||1;
    const para_wordtags = params.get('wordtag') ||'all';
    return { para_name, para_rating, para_reviews, para_sort_by,para_page,para_wordtags};
    
  };
  
  export const parselemmaUrlParams = () => {
    const { pathname, search } = window.location;
    const { para_type } = parsePathParams(pathname);
    const { para_name, para_rating, para_reviews, para_sort_by,para_page,para_wordtags } = parseQueryParams(search);
  
    return { para_type, para_name, para_rating, para_reviews, para_sort_by, para_page,para_wordtags };
  };

  const parseProgressQueryParams = (search) => {
    const params = new URLSearchParams(search);
    const para_period = params.get('period') || 'day';
    const para_name = params.get('name') || 'all';
    const para_rating = params.get('rating') || '=-1';// not using 
    const para_reviews = params.get('review') || '=-1'; // not using 
    const para_sort_by = params.get('sort') || 'best-match';
    const para_page = params.get('page') ||1;
    const para_wordtag = params.get('wordtag') ||'all';
    return { para_name, para_rating, para_reviews, para_sort_by,para_page,para_wordtag,para_period};
    
  };

  export const parseProgressUrlParams = () => {
    const { pathname, search } = window.location;
    const { para_type } = parsePathParams(pathname);
    const { para_name, para_rating, para_reviews, para_sort_by,para_page,para_wordtag,para_period } = parseProgressQueryParams(search);
  
    return { para_type, para_name, para_rating, para_reviews, para_sort_by, para_page,para_wordtag,para_period };
  };
